import PropTypes from 'prop-types';
import {alpha} from "@mui/material/styles";

// ==============================|| CUSTOM FUNCTION - COLOR SHADOWS ||============================== //

const getShadow = (theme, shadow) => {
  switch (shadow) {
    case 'secondary':
      return `0 0 0 2px ${alpha(theme.palette.secondary.main, 0.2)}`;
    case 'error':
      return `0 0 0 2px ${alpha(theme.palette.error.main, 0.2)}`;
    case 'warning':
      return `0 0 0 2px ${alpha(theme.palette.warning.main, 0.2)}`;
    case 'info':
      return `0 0 0 2px ${alpha(theme.palette.info.main, 0.2)}`;
    case 'success':
      return `0 0 0 2px ${alpha(theme.palette.success.main, 0.2)}`;
    case 'primaryButton':
      return `0 14px 12px ${alpha(theme.palette.primary.main, 0.2)}`;
    case 'secondaryButton':
      return `0 14px 12px ${alpha(theme.palette.secondary.main, 0.2)}`;
    case 'errorButton':
      return `0 14px 12px ${alpha(theme.palette.error.main, 0.2)}`;
    case 'warningButton':
      return `0 14px 12px ${alpha(theme.palette.warning.main, 0.2)}`;
    case 'infoButton':
      return `0 14px 12px ${alpha(theme.palette.info.main, 0.2)}`;
    case 'successButton':
      return `0 14px 12px ${alpha(theme.palette.success.main, 0.2)}`;
    default:
      return `0 0 0 2px ${alpha(theme.palette.primary.main, 0.2)}`;
  }
};

getShadow.propTypes = {
  theme: PropTypes.object,
  shadow: PropTypes.string
};

export default getShadow;
